import * as PDFJS from 'pdfjs-dist';

// Configure PDF.js worker
const pdfjsWorker = new URL('pdfjs-dist/build/pdf.worker.mjs', import.meta.url);

PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker.href;

export async function extractTextFromPDF(file: File): Promise<string> {
  try {
    // Convert File to ArrayBuffer
    const arrayBuffer = await file.arrayBuffer();

    // Load the PDF document
    const pdf = await PDFJS.getDocument({ data: arrayBuffer }).promise;

    // Extract text from all pages
    const maxPages = pdf.numPages;
    const textContent: string[] = [];

    for (let pageNum = 1; pageNum <= maxPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const content = await page.getTextContent();
      const text = content.items.map((item: any) => item.str).join(' ');
      textContent.push(text);
    }

    return textContent.join('\n\n');
  } catch (error) {
    console.error('Error extracting text from PDF:', error);
    throw new Error('Failed to extract text from PDF');
  }
}
